<div class="auth-page">
  <div class="auth-card">

    <div class="auth-logo">
      <div class="mail-icon-wrap">
        <ngk-icon icon="mail" size="1.75rem" color="var(--color-secondary-700)" />
      </div>
    </div>

    <h1 class="auth-title">Check your email</h1>
    <p class="auth-subtitle">
      We sent a 6-digit code to<br />
      <strong class="auth-email">{{ email }}</strong>
    </p>

    <div class="otp-group" (paste)="onPaste($event)">
      @for (digit of digits; track $index) {
        <input
          #digitInput
          class="otp-input"
          type="text"
          inputmode="numeric"
          maxlength="1"
          [value]="digit"
          (input)="onInput($index, $event)"
          (keydown)="onKeydown($index, $event)"
          autocomplete="one-time-code"
        />
      }
    </div>

    @if (invalidCode || errorMessage) {
      <p class="error-msg">
        <ngk-icon icon="circle-x" size="0.9rem" color="var(--color-warning-600)" />
        {{ errorMessage || 'Invalid code. Please try again.' }}
      </p>
    }

    <button
      ngkButton
      color="secondary"
      mode="solid"
      size="md"
      class="auth-btn"
      [disabled]="!isComplete || verifying"
      (click)="verify()"
    >
      {{ verifying ? 'Verifying...' : 'Verify code' }}
    </button>

    <div class="auth-actions">
      <p class="resend-text">
        Didn't receive a code?
        @if (resendSent) {
          <span class="resend-sent">Code resent!</span>
        } @else {
          <button class="text-btn" (click)="resend()">Resend</button>
        }
      </p>
      <button class="back-link" (click)="back()">← Back</button>
    </div>

  </div>
</div>
